import { ResortToolsConfig } from './resortToolsConfig';
import * as R from 'ramda';


/**
 * The default configuration to use for the Resort Tools in all environments including production -- failing overrides
 * from the build process or index.html runtime config.
 */
export const DEFAULT_CONFIG: ResortToolsConfig = R.mergeDeepRight(
  {
    apiCircuitBreaker:          {
      failureMax:       3,
      coolDownPeriodMs: 60000,
    },

    dtwCategoryId:              1,
    fnfCategoryId:              2,
    isUat:                      false,
    autoLogoutTimerMs:          15 * 60 * 1000,
    loginForwardToTargetMs:     60 * 60 * 1000,
    userRoles:                  [ 'sysadmin', 'admin', 'manager', 'agent' ],
    enableAddToHotlist:         [ 'sysadmin', 'admin', 'manager' ],
    enableRemoveFromHotlist:    [ 'sysadmin', 'admin', 'manager' ],
    enableGlobalHotlist:        false,
    enableResortSpecificHotlist: true,
    enableDtw:                  [ ],
    enableCorrectiveRedemption: [ 'sysadmin', 'admin', 'manager' ],
    enableGlobalRedemption:     [ 'sysadmin' ],
    enableDisableMedia:         [ 'sysadmin', 'admin', 'manager' ],
    manageSystemAdmin:          [ 'sysadmin' ],
    isConfigLoaded:             false,
    manageResortAdmin:          [ 'sysadmin', 'admin' ],
    manageUsers:                [ 'sysadmin', 'admin' ],
    manageDays:                 [ 'sysadmin', 'admin', 'manager' ],
    enableHotlistReport:        [ 'sysadmin' ],
    enableGuestHydrationReport: [ 'sysadmin' ],
    enableWeeklyVisitorReport:  [ 'sysadmin' ],
    enablePassUsageCorrection:  [ 'sysadmin' ],
    manageProductAdministration:[ 'sysadmin' ],
    enableRedemptionDisplayOnly: false,
    resortId:                     1,
    activeEntitlementsOnly:       true,
    enableSyncCustomerMediaUpdate: true,
    enableCustomerImport: [ ],
    manageValidationConfiguration: ['sysadmin','admin'],
    manageHelpDocs: ['sysadmin'],
    enableProductMapping: ['sysadmin', 'admin', 'manager'],
    bulkUploadUsers: ['sysadmin', 'admin'],
    phoneInputCountryList: ['ca','us','jp','fr','cl','it','ch','ad','at','au','nz'],
    enableSearchHistory: false,
    enablePowCoin: false,
    enableChangeHistory: false,
    enableMappingErrorBanner: false,
    enableFriendsAndFamily: true,
    enableResortHydrationUIFeatures: false,
    weeklyVisitorReportLimit: 0,
    enablePassReprintNotifications: false,
    displayDeactivatedMediaHistory: false,
    globalConfigs: {}
  },
  JSON.parse(process.env.buildArgs || '{}') as ResortToolsConfig,
)as any;
